import { dayjs, toDayjsLocale } from './dayjsSetup';

export type DateInput = Date | string | number;

const SHORT_DATE_TIME_FORMATS: Record<string, string> = {
  cs: 'DD.MM.YYYY H:mm',
  de: 'DD.MM.YYYY HH:mm',
  en: 'M/D/YYYY h:mm A',
  hu: 'YYYY. MM. DD. H:mm',
  it: 'DD/MM/YYYY HH:mm',
  ro: 'DD.MM.YYYY HH:mm',
  sk: 'D. M. YYYY H:mm',
};

const SHORT_DATE_FORMATS: Record<string, string> = {
  cs: 'DD.MM.YYYY',
  de: 'DD.MM.YYYY',
  en: 'M/D/YYYY',
  hu: 'YYYY. MM. DD.',
  it: 'DD/MM/YYYY',
  ro: 'DD.MM.YYYY',
  sk: 'D. M. YYYY',
};

const SHORT_TIME_FORMATS: Record<string, string> = {
  cs: 'H:mm',
  de: 'HH:mm',
  en: 'h:mm A',
  hu: 'H:mm',
  it: 'HH:mm',
  ro: 'HH:mm',
  sk: 'H:mm',
};

export function formatToRelativeTime(date: DateInput, locale: string): string {
  return dayjs(date).locale(toDayjsLocale(locale)).fromNow();
}

export function toCalendarTime(date: DateInput, locale: string): string {
  const dayjsLocale = toDayjsLocale(locale);
  const format = SHORT_DATE_TIME_FORMATS[dayjsLocale] ?? 'L LT';
  return dayjs(date).locale(dayjsLocale).format(format);
}

export function toTime(date: DateInput, locale: string): string {
  const dayjsLocale = toDayjsLocale(locale);
  const format = SHORT_TIME_FORMATS[dayjsLocale] ?? 'LT';
  return dayjs(date).locale(dayjsLocale).format(format);
}

export function toShortDate(date: DateInput, locale: string): string {
  const dayjsLocale = toDayjsLocale(locale);
  const format = SHORT_DATE_FORMATS[dayjsLocale] ?? 'L';
  return dayjs(date).locale(dayjsLocale).format(format);
}
